export interface StoredUserIdentity {
  id?: string | null
  _id?: string | null
  userId?: string | null
}

function normalizeIdentifier(value: unknown): string | null {
  if (typeof value !== 'string') return null
  const trimmed = value.trim()
  return trimmed ? trimmed : null
}

export function isMongoObjectId(value: unknown): value is string {
  return typeof value === 'string' && /^[0-9a-fA-F]{24}$/.test(value.trim())
}

export function getPreferredUserIdentifier(user: StoredUserIdentity | null | undefined): string | null {
  if (!user) return null

  const candidates = [
    normalizeIdentifier(user._id),
    normalizeIdentifier(user.id),
    normalizeIdentifier(user.userId),
  ].filter((value): value is string => Boolean(value))

  return candidates.find((value) => isMongoObjectId(value)) || candidates[0] || null
}
